import { render, staticRenderFns } from "./RecruiterStackRanking.vue?vue&type=template&id=9a3195ec&"
import script from "./RecruiterStackRanking.vue?vue&type=script&lang=js&"
export * from "./RecruiterStackRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports